<div class="grid grid-cols-12 gap-4 md:gap-6">
  <div class="col-span-12 space-y-6 xl:col-span-12">
    <div><app-ecommerce-metrics /></div>

    <div><app-monthly-sales-chart /></div>
  </div>

  <!-- <div class="col-span-12">
    <app-statics-chart />
  </div> -->
</div>